// extracted by mini-css-extract-plugin
export default {"button":"add-button_button__C3KTJ","text":"add-button_text__yDGgO"};